(function ($) {
  $(function () {
    function updateHeaderHeight() {
      var totalHeight = $('header > .wp-block-group').outerHeight();
      document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
    }

    // Initial calculation
    updateHeaderHeight();

    // Recalculate on window resize
    $(window).on('resize', function () {
      updateHeaderHeight();
    });

    function addWrapClasses() {
      const $header = $('header');
      const $menuItems = $(
        `header nav[aria-label="Header Main Nav"] .wp-block-navigation__container > .wp-block-navigation-item`
      );

      $header.removeClass('mobile-menu');

      if ($menuItems.length < 2) return;

      const firstTop = $menuItems.first().offset().top;
      let wrapped = false;

      $menuItems.each(function () {
        if ($(this).offset().top > firstTop) {
          wrapped = true;
          return false;
        }
      });

      if (wrapped) {
        $header.addClass('mobile-menu');
      }
    }

    addWrapClasses();
    $(window).on('resize', addWrapClasses);
  });
})(jQuery);
